import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterSection = ({ 
  selectedDifficulty, 
  setSelectedDifficulty, 
  selectedCostRange, 
  setSelectedCostRange 
}) => {
  const difficultyOptions = [
    { value: 'all', label: 'Alle niveaus' },
    { value: 'beginner', label: 'Beginner' },
    { value: 'intermediate', label: 'Gemiddeld' },
    { value: 'advanced', label: 'Gevorderd' }
  ];

  const costRangeOptions = [
    { value: 'all', label: 'Alle budgetten' },
    { value: 'low', label: '€0 - €2.500' },
    { value: 'medium', label: '€2.500 - €10.000' },
    { value: 'high', label: '€10.000+' }
  ];

  return (
    <section className="bg-muted/30 border-b border-border py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <div className="flex items-center space-x-2">
            <Icon name="Filter" size={18} className="text-muted-foreground" />
            <span className="text-sm font-body font-medium text-foreground">Filters:</span>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 flex-1">
            <div className="flex-1 min-w-[200px]">
              <Select
                value={selectedDifficulty}
                onChange={(e) => setSelectedDifficulty(e?.target?.value)}
                options={difficultyOptions}
                className="w-full"
              />
            </div>
            
            <div className="flex-1 min-w-[200px]">
              <Select
                value={selectedCostRange}
                onChange={(e) => setSelectedCostRange(e?.target?.value)}
                options={costRangeOptions}
                className="w-full"
              />
            </div>
          </div>
          
          {(selectedDifficulty !== 'all' || selectedCostRange !== 'all') && (
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              onClick={() => {
                setSelectedDifficulty('all');
                setSelectedCostRange('all');
              }}
              className="flex items-center space-x-1 text-sm font-body text-primary hover:text-primary/80 transition-colors"
            >
              <Icon name="X" size={16} />
              <span>Reset filters</span>
            </motion.button>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default FilterSection;